//来源
export const system_source = 'WEB';
// 基础信息
export const application_title = '数城科技';
//接口请求基础域名
export const base_url = '/';
// 请求地址
export const request_url = base_url + 'api/';
// 静态资源地址
export const static_url = request_url + 'source/';
//请求超时时间，毫秒（默认1分钟）
export const timeout = 60000;
